
declare interface String {
  // replaceAll: (search, replacemen) => string;
  capitalize: () => string;
}

// String.prototype.replaceAll = function (search, replacement) {
//   const target = this;
//   return target.replace(new RegExp(search, 'g'), replacement);
// };

String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
}